<template>
    <div>
        <van-nav-bar
                title="抄表记录"
                left-arrow
                :fixed="true"
                :placeholder="true"
                @click-left="onClickLeft"
        >
        </van-nav-bar>
        <div class="meter-table">
            <div class="meter-header">
                <span class="col-date">抄表时间</span>
                <span>电表读数</span>
                <span>用电量</span>
                <span>水表读数</span>
                <span>用水量</span>
            </div>
            <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
                <van-list
                        v-model="loading"
                        :finished="finished"
                        finished-text="没有更多了"
                        @load="onLoad"
                >
                    <div class="meter-row" v-for="(item, index) in list" :key="index">
                        <span class="col-date">{{ formatDate(item.meterDate) }}</span>
                        <span>{{ item.electricityMeter }}</span>
                        <span>{{ item.electricityAmount }}</span>
                        <span>{{ item.waterMeter }}</span>
                        <span>{{ item.waterAmount }}</span>
                    </div>
                </van-list>
            </van-pull-refresh>
        </div>
    </div>
</template>

<script>
    import { DateFormat } from "@/common/utils";

    export default {
        name: "meter-records-index",
        components: {
        },
        data() {
            return {
                roomId: "",
                list: [],
                loading: false,
                finished: false,
                refreshing: false,
                current: 1,
                size: 20,
            }
        },
        created() {
            this.roomId = this.$route.query.roomId;
        },
        methods: {
            onLoad() {
                this.$get('/rental/listByRoom', { roomId: this.roomId, current: this.current, size: this.size }).then(({data}) => {
                    const records = data.records || [];
                    this.list = this.list.concat(records);
                    this.finished = this.list.length >= (data.total || 0);
                    this.current += 1;
                }).catch(() => {
                    this.finished = true;
                }).finally(() => {
                    this.loading = false;
                    if (this.refreshing) {
                        this.refreshing = false;
                    }
                });
            },
            onRefresh() {
                this.current = 1;
                this.finished = false;
                this.list = [];
                this.onLoad();
            },
            formatDate(val) {
                if (!val) {
                    return '';
                }
                return DateFormat(new Date(val), 'yyyy-MM-dd');
            },
            onClickLeft() {
                this.$goBack();
            },
        }
    }
</script>

<style scoped lang="less">
    .van-nav-bar{
        background-color: #409EFF;
        .van-nav-bar__title{
            color: #ffffff;
        }
    }
    .meter-table{
        padding: 10px 16px;
        font-size: 12px;
        .meter-header, .meter-row{
            display: flex;
            text-align: center;
            span{
                flex: 1;
                padding: 10px 4px;
                word-break: break-all;
            }
            .col-date{
                flex: 1.4;
            }
        }
        .meter-header{
            background-color: #f7f8fa;
            color: #323233;
            font-weight: bold;
        }
        .meter-row{
            border-bottom: 1px solid #ebedf0;
            color: #646566;
            &:nth-child(odd){
                background-color: #ffffff;
            }
        }
    }
</style>
